import {MentionNode} from "../plugins/mentions/node/node"

const debug = false
// const debug = "lexicalFindMentions"

export function lexicalFindMentions(lexicalJSON?: {root:any}) {
    debug && console.log(debug, 'process')

    const findMentions = (node:any, mentions: any[] = []) => {
        if (node.type === MentionNode.getType()) mentions.push(node.mentionData)

        _.map(node.children, childNode => {
            mentions = findMentions(childNode, mentions)
        })

        return mentions
    }

    return lexicalJSON ? findMentions(lexicalJSON.root) : []
}